import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Layout, Skeleton } from "antd";

import {
  initPrestationSlice,
  setLoading,
  setLoadingAsync,
  setPropertiesPrestation,
  updatePrestation,
} from "../Slices/Prestation.slice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { prestationInputs } from "./PrestationDetailForm";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import { UserContext } from "../../../engine/context/User.context";
import {
  RenderCommentAdmin,
  RenderControl1,
  RenderControl2,
} from "../PrestationResume/PrestationsResumeActions";
import { http } from "../../../engine/api/http";
import { prestationAlreadyExist } from "../../../shared/components/Modals/modals";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import { isSuperAdmin } from "../../../engine/hooks/hooks.helpers";
import {
  statusPrestations,
  statusPrestationsValues,
} from "../../../utils/constants";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationDetail({ isNew }) {
  const { id } = useParams();
  const { prestation, loading } = useSelector(state => state.prestation);
  const { init, clear, ready } = initPrestationSlice({ id });
  const [change, setChange] = useState(undefined);
  const { user } = useContext(UserContext);

  const initDataForm = {};

  if (user.role === "institution" && id === "new") {
    initDataForm.institution = user.institution?._id;
  }

  const [dataForm, setDataForm] = useState(initDataForm);

  const [readyBySelector, setReadyBySelector] = useState(false);

  const location = useLocation();
  const formRef = useRef(null);
  const lock = useRef(false); // Utilisé pour verrouiller la soumission

  //
  useEffect(() => {
    if (prestation.institution !== undefined) {
      setDataForm({
        ...dataForm,
        institution: prestation.institution,
      });
    }

    formRef?.current?.setFieldsValue({
      category: prestation.category,
    });
  }, [prestation.institution, formRef]);

  const initialozerSelector = async () => {
    let initDatas = {
      institution: {
        _id: location.state.institution,
      },
      intervention: {
        type: location.state["intervention.type"],
        linkVisio: location.state["intervention.linkVisio"] || "",
        phone: location.state["intervention.phone"] || "",
        startDate: location.state["start"],
        endDate: location.state["end"],
      },
      language: [location.state.language],
    };

    await dispatch(
      setPropertiesPrestation({
        ...initDatas,
        selector: {
          ...initDatas,
          interprete: location.state.interpretes,
        },
      }),
    );

    setDataForm(initDatas);

    setReadyBySelector(true);
  };

  useEffect(() => {
    if (location?.state !== null && prestation._id === undefined) {
      initialozerSelector();
    } else {
      setReadyBySelector(true);
    }
  }, []);

  const superAdmin = isSuperAdmin();

  const [disabled] = usePrestationDisabler();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmitForm = async data => {
    if (lock.current) return; // Empêche le spam

    lock.current = true; // Verrouille la soumission

    let caller = await dispatch(setLoading(true));

    const alreadyExist = await http.post(`/prestations/exist`, {
      ...data,
      notPrestationId: prestation._id,
    });

    if (alreadyExist.data.length > 0) {
      await prestationAlreadyExist({
        content: {
          prestations: alreadyExist.data,
        },
        onOk: async () => {
          await handleFormSubmission(data); // Call the form submission handling function
          await dispatch(setLoading(false));
          lock.current = false; // Déverrouille après la soumission
        },
        onCancel: async () => {
          await dispatch(setLoading(false));
          lock.current = false; // Déverrouille après la soumission
          // Stop
        },
      });
    } else {
      await handleFormSubmission(data); // Call the form submission handling function if no modal is needed
      await dispatch(setLoading(false));
      lock.current = false; // Déverrouille après la soumission
    }
  };

  const handleFormSubmission = async data => {
    /* Check if data.steps exists, and if not, create it as an empty object
     * data.steps ??= {} checks if data.steps is null or undefined. If it is, it creates an empty object {} and assigns it to data.steps. If data.steps already exists, it remains unchanged.
     */
    data.steps ??= {};

    data.steps.searchInterpretes = true;

    await dispatch(setPropertiesPrestation(data));
    let actionResult = await dispatch(updatePrestation());

    if (
      actionResult.meta.requestStatus !== "rejected" &&
      prestation._id !== undefined
    ) {
      await navigate(routes.prestations(id).detailInterpretes.path);
    }
  };

  const onValuesChange = (changedValues, all) => {
    setDataForm(all);
    Object.keys(changedValues).map(changed => {
      switch (changed) {
        case "institution":
          if (
            prestation.institution !== undefined &&
            (prestation.institution._id !== undefined ||
              prestation.institution._id !== changedValues[changed])
          ) {
            const body = {
              billing: null,
              institutionBilling: null,
            };

            if (!superAdmin) {
              body.steps = {
                ...prestation.steps,
                facturation: false,
                resume: false,
              };
            }

            dispatch(setPropertiesPrestation(body));
          }

          formRef.current.setFieldsValue({
            category: [],
            applicant: undefined,
            "intervention.extra": "",
            "intervention.locationFrom": "",
            "intervention.location": "",
            "intervention.locationName": "",
            "responsable.firstname": "",
            "responsable.email": "",
            "responsable.phone": "",
            "responsable.lastname": "",
          });

          dispatch(
            setPropertiesPrestation({
              category: [],
              intervention: {
                ...prestation.intervention,
                extra: "",
                locationFrom: "",
                location: "",
                locationName: "",
              },
              responsable: {
                firstname: "",
                email: "",
                phone: "",
                lastname: "",
              },
            }),
          );

          break;
      }
    });
  };

  return (
    <div key={prestation._id || "new"}>
      <PrestationHeader title={routes.prestations(id).detail.title} />
      {/*{loading || !ready || readyBySelector === false ? (*/}
      {/*  <Skeleton active />*/}
      {/*) : (*/}
      <div>
        <br />
        <RenderCommentAdmin key={prestation._id} />
        <RenderControl1 key={prestation._id} />
        <RenderControl2 key={prestation._id} />
        <CustomForm
          // a newer copy of the booking from the server replaces what the form was opened with
          key={prestation.updatedAt ?? "new"}
          disabled={disabled || loading || lock.current}
          initialValues={prestation}
          dataSource={prestationInputs(
            prestation,
            formRef,
            change,
            setChange,
            user,
            dataForm,
            setDataForm,
            loading,
          )}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={onValuesChange}
        />
      </div>
      {/*)}*/}
    </div>
  );
}
